var map = {
	"./": [
		2176
	],
	"./Calc_AUDIT": [
		9782,
		529
	],
	"./Calc_AUDIT/": [
		9782,
		529
	],
	"./Calc_AUDIT/Info": [
		4076,
		4076
	],
	"./Calc_AUDIT/Info.tsx": [
		4076,
		4076
	],
	"./Calc_AUDIT/index": [
		9782,
		529
	],
	"./Calc_AUDIT/index.tsx": [
		9782,
		529
	],
	"./Calc_Alvarado": [
		9840,
		9840
	],
	"./Calc_Alvarado/": [
		9840,
		9840
	],
	"./Calc_Alvarado/Info": [
		1237,
		1237
	],
	"./Calc_Alvarado/Info.tsx": [
		1237,
		1237
	],
	"./Calc_Alvarado/index": [
		9840,
		9840
	],
	"./Calc_Alvarado/index.tsx": [
		9840,
		9840
	],
	"./Calc_Apgar": [
		8588,
		8588
	],
	"./Calc_Apgar/": [
		8588,
		8588
	],
	"./Calc_Apgar/Info": [
		3714,
		3714
	],
	"./Calc_Apgar/Info.tsx": [
		3714,
		3714
	],
	"./Calc_Apgar/index": [
		8588,
		8588
	],
	"./Calc_Apgar/index.jsx": [
		8588,
		8588
	],
	"./Calc_BSA": [
		359,
		359
	],
	"./Calc_BSA/": [
		359,
		359
	],
	"./Calc_BSA/Info": [
		6179,
		6179
	],
	"./Calc_BSA/Info.tsx": [
		6179,
		6179
	],
	"./Calc_BSA/index": [
		359,
		359
	],
	"./Calc_BSA/index.jsx": [
		359,
		359
	],
	"./Calc_BirthDate": [
		1345,
		1345
	],
	"./Calc_BirthDate/": [
		1345,
		1345
	],
	"./Calc_BirthDate/Info": [
		7035,
		7035
	],
	"./Calc_BirthDate/Info.tsx": [
		7035,
		7035
	],
	"./Calc_BirthDate/index": [
		1345,
		1345
	],
	"./Calc_BirthDate/index.jsx": [
		1345,
		1345
	],
	"./Calc_CAGE": [
		6294,
		6294
	],
	"./Calc_CAGE/": [
		6294,
		6294
	],
	"./Calc_CAGE/Info": [
		6097,
		6097
	],
	"./Calc_CAGE/Info.tsx": [
		6097,
		6097
	],
	"./Calc_CAGE/index": [
		6294,
		6294
	],
	"./Calc_CAGE/index.tsx": [
		6294,
		6294
	],
	"./Calc_CFExercise": [
		4106,
		4106
	],
	"./Calc_CFExercise/": [
		4106,
		4106
	],
	"./Calc_CFExercise/Info": [
		3586,
		3586
	],
	"./Calc_CFExercise/Info.tsx": [
		3586,
		3586
	],
	"./Calc_CFExercise/index": [
		4106,
		4106
	],
	"./Calc_CFExercise/index.jsx": [
		4106,
		4106
	],
	"./Calc_CKD": [
		4301,
		4301
	],
	"./Calc_CKD/": [
		4301,
		4301
	],
	"./Calc_CKD/Info": [
		4033,
		1372
	],
	"./Calc_CKD/Info.tsx": [
		4033,
		1372
	],
	"./Calc_CKD/index": [
		4301,
		4301
	],
	"./Calc_CKD/index.jsx": [
		4301,
		4301
	],
	"./Calc_CURB": [
		8029,
		8029
	],
	"./Calc_CURB/": [
		8029,
		8029
	],
	"./Calc_CURB/Info": [
		2101,
		2101
	],
	"./Calc_CURB/Info.tsx": [
		2101,
		2101
	],
	"./Calc_CURB/index": [
		8029,
		8029
	],
	"./Calc_CURB/index.tsx": [
		8029,
		8029
	],
	"./Calc_Chads2": [
		5085,
		5085
	],
	"./Calc_Chads2/": [
		5085,
		5085
	],
	"./Calc_Chads2/Info": [
		9953,
		9953
	],
	"./Calc_Chads2/Info.tsx": [
		9953,
		9953
	],
	"./Calc_Chads2/index": [
		5085,
		5085
	],
	"./Calc_Chads2/index.tsx": [
		5085,
		5085
	],
	"./Calc_CrCl": [
		8962,
		8962
	],
	"./Calc_CrCl/": [
		8962,
		8962
	],
	"./Calc_CrCl/Info": [
		7424,
		7424
	],
	"./Calc_CrCl/Info.tsx": [
		7424,
		7424
	],
	"./Calc_CrCl/index": [
		8962,
		8962
	],
	"./Calc_CrCl/index.jsx": [
		8962,
		8962
	],
	"./Calc_Eag": [
		8284,
		8284
	],
	"./Calc_Eag/": [
		8284,
		8284
	],
	"./Calc_Eag/Info": [
		2539,
		2539
	],
	"./Calc_Eag/Info.tsx": [
		2539,
		2539
	],
	"./Calc_Eag/index": [
		8284,
		8284
	],
	"./Calc_Eag/index.tsx": [
		8284,
		8284
	],
	"./Calc_Epworth": [
		5516,
		5516
	],
	"./Calc_Epworth/": [
		5516,
		5516
	],
	"./Calc_Epworth/Info": [
		5400,
		5400
	],
	"./Calc_Epworth/Info.tsx": [
		5400,
		5400
	],
	"./Calc_Epworth/index": [
		5516,
		5516
	],
	"./Calc_Epworth/index.tsx": [
		5516,
		5516
	],
	"./Calc_Findrisk": [
		1557,
		1557
	],
	"./Calc_Findrisk/": [
		1557,
		1557
	],
	"./Calc_Findrisk/Info": [
		1411,
		1411
	],
	"./Calc_Findrisk/Info.tsx": [
		1411,
		1411
	],
	"./Calc_Findrisk/index": [
		1557,
		1557
	],
	"./Calc_Findrisk/index.tsx": [
		1557,
		1557
	],
	"./Calc_Framingham": [
		6434,
		6434
	],
	"./Calc_Framingham/": [
		6434,
		6434
	],
	"./Calc_Framingham/Info": [
		7102,
		7102
	],
	"./Calc_Framingham/Info.tsx": [
		7102,
		7102
	],
	"./Calc_Framingham/index": [
		6434,
		6434
	],
	"./Calc_Framingham/index.tsx": [
		6434,
		6434
	],
	"./Calc_FraminghamIMC": [
		6169,
		6169
	],
	"./Calc_FraminghamIMC/": [
		6169,
		6169
	],
	"./Calc_FraminghamIMC/Info": [
		3551,
		3551
	],
	"./Calc_FraminghamIMC/Info.tsx": [
		3551,
		3551
	],
	"./Calc_FraminghamIMC/index": [
		6169,
		6169
	],
	"./Calc_FraminghamIMC/index.tsx": [
		6169,
		6169
	],
	"./Calc_GRACE": [
		4936,
		4936
	],
	"./Calc_GRACE/": [
		4936,
		4936
	],
	"./Calc_GRACE/Info": [
		3261,
		3261
	],
	"./Calc_GRACE/Info.tsx": [
		3261,
		3261
	],
	"./Calc_GRACE/index": [
		4936,
		4936
	],
	"./Calc_GRACE/index.jsx": [
		4936,
		4936
	],
	"./Calc_Geneve": [
		3084,
		3084
	],
	"./Calc_Geneve/": [
		3084,
		3084
	],
	"./Calc_Geneve/Info": [
		5017,
		5017
	],
	"./Calc_Geneve/Info.tsx": [
		5017,
		5017
	],
	"./Calc_Geneve/index": [
		3084,
		3084
	],
	"./Calc_Geneve/index.tsx": [
		3084,
		3084
	],
	"./Calc_Glasgow": [
		6942,
		6942
	],
	"./Calc_Glasgow/": [
		6942,
		6942
	],
	"./Calc_Glasgow/Info": [
		6806,
		6806
	],
	"./Calc_Glasgow/Info.tsx": [
		6806,
		6806
	],
	"./Calc_Glasgow/index": [
		6942,
		6942
	],
	"./Calc_Glasgow/index.jsx": [
		6942,
		6942
	],
	"./Calc_HEART": [
		2989,
		2989
	],
	"./Calc_HEART/": [
		2989,
		2989
	],
	"./Calc_HEART/Info": [
		796,
		796
	],
	"./Calc_HEART/Info.tsx": [
		796,
		796
	],
	"./Calc_HEART/index": [
		2989,
		2989
	],
	"./Calc_HEART/index.jsx": [
		2989,
		2989
	],
	"./Calc_Hasbled": [
		506,
		506
	],
	"./Calc_Hasbled/": [
		506,
		506
	],
	"./Calc_Hasbled/Info": [
		2732,
		2732
	],
	"./Calc_Hasbled/Info.tsx": [
		2732,
		2732
	],
	"./Calc_Hasbled/index": [
		506,
		506
	],
	"./Calc_Hasbled/index.tsx": [
		506,
		506
	],
	"./Calc_IMC": [
		6850,
		6850
	],
	"./Calc_IMC/": [
		6850,
		6850
	],
	"./Calc_IMC/Info": [
		752,
		752
	],
	"./Calc_IMC/Info.tsx": [
		752,
		752
	],
	"./Calc_IMC/index": [
		6850,
		6850
	],
	"./Calc_IMC/index.jsx": [
		6850,
		6850
	],
	"./Calc_IMPROVE": [
		4289,
		4289
	],
	"./Calc_IMPROVE/": [
		4289,
		4289
	],
	"./Calc_IMPROVE/Info": [
		9652,
		9652
	],
	"./Calc_IMPROVE/Info.tsx": [
		9652,
		9652
	],
	"./Calc_IMPROVE/index": [
		4289,
		4289
	],
	"./Calc_IMPROVE/index.tsx": [
		4289,
		4289
	],
	"./Calc_Killip": [
		2393,
		2393
	],
	"./Calc_Killip/": [
		2393,
		2393
	],
	"./Calc_Killip/Info": [
		9354,
		9354
	],
	"./Calc_Killip/Info.tsx": [
		9354,
		9354
	],
	"./Calc_Killip/index": [
		2393,
		2393
	],
	"./Calc_Killip/index.jsx": [
		2393,
		2393
	],
	"./Calc_LRINEC": [
		7695,
		7695
	],
	"./Calc_LRINEC/": [
		7695,
		7695
	],
	"./Calc_LRINEC/Info": [
		1497,
		1497
	],
	"./Calc_LRINEC/Info.tsx": [
		1497,
		1497
	],
	"./Calc_LRINEC/index": [
		7695,
		7695
	],
	"./Calc_LRINEC/index.tsx": [
		7695,
		7695
	],
	"./Calc_MEEM": [
		6118,
		381
	],
	"./Calc_MEEM/": [
		6118,
		381
	],
	"./Calc_MEEM/Info": [
		1310,
		1310
	],
	"./Calc_MEEM/Info.tsx": [
		1310,
		1310
	],
	"./Calc_MEEM/index": [
		6118,
		381
	],
	"./Calc_MEEM/index.tsx": [
		6118,
		381
	],
	"./Calc_MEWS": [
		8370,
		8370
	],
	"./Calc_MEWS/": [
		8370,
		8370
	],
	"./Calc_MEWS/Info": [
		1892,
		1892
	],
	"./Calc_MEWS/Info.tsx": [
		1892,
		1892
	],
	"./Calc_MEWS/index": [
		8370,
		8370
	],
	"./Calc_MEWS/index.tsx": [
		8370,
		8370
	],
	"./Calc_MOCA": [
		4382,
		4382
	],
	"./Calc_MOCA/": [
		4382,
		4382
	],
	"./Calc_MOCA/Info": [
		4866,
		4866
	],
	"./Calc_MOCA/Info.tsx": [
		4866,
		4866
	],
	"./Calc_MOCA/index": [
		4382,
		4382
	],
	"./Calc_MOCA/index.tsx": [
		4382,
		4382
	],
	"./Calc_NEWS": [
		3993,
		3993
	],
	"./Calc_NEWS/": [
		3993,
		3993
	],
	"./Calc_NEWS/Info": [
		224,
		224
	],
	"./Calc_NEWS/Info.tsx": [
		224,
		224
	],
	"./Calc_NEWS/index": [
		3993,
		3993
	],
	"./Calc_NEWS/index.tsx": [
		3993,
		3993
	],
	"./Calc_NIHSS": [
		7565,
		7565
	],
	"./Calc_NIHSS/": [
		7565,
		7565
	],
	"./Calc_NIHSS/Info": [
		3204,
		3204
	],
	"./Calc_NIHSS/Info.tsx": [
		3204,
		3204
	],
	"./Calc_NIHSS/index": [
		7565,
		7565
	],
	"./Calc_NIHSS/index.tsx": [
		7565,
		7565
	],
	"./Calc_Oakland": [
		4278,
		4278
	],
	"./Calc_Oakland/": [
		4278,
		4278
	],
	"./Calc_Oakland/Info": [
		2106,
		2106
	],
	"./Calc_Oakland/Info.tsx": [
		2106,
		2106
	],
	"./Calc_Oakland/index": [
		4278,
		4278
	],
	"./Calc_Oakland/index.tsx": [
		4278,
		4278
	],
	"./Calc_PAAS": [
		9622,
		9622
	],
	"./Calc_PAAS/": [
		9622,
		9622
	],
	"./Calc_PAAS/Info": [
		3248,
		3248
	],
	"./Calc_PAAS/Info.tsx": [
		3248,
		3248
	],
	"./Calc_PAAS/index": [
		9622,
		9622
	],
	"./Calc_PAAS/index.tsx": [
		9622,
		9622
	],
	"./Calc_PERC": [
		3601,
		3601
	],
	"./Calc_PERC/": [
		3601,
		3601
	],
	"./Calc_PERC/Info": [
		7006,
		7006
	],
	"./Calc_PERC/Info.tsx": [
		7006,
		7006
	],
	"./Calc_PERC/index": [
		3601,
		3601
	],
	"./Calc_PERC/index.jsx": [
		3601,
		3601
	],
	"./Calc_PESI": [
		693,
		693
	],
	"./Calc_PESI/": [
		693,
		693
	],
	"./Calc_PESI/Info": [
		6962,
		6962
	],
	"./Calc_PESI/Info.tsx": [
		6962,
		6962
	],
	"./Calc_PESI/index": [
		693,
		693
	],
	"./Calc_PESI/index.tsx": [
		693,
		693
	],
	"./Calc_PEWS": [
		8456,
		8456
	],
	"./Calc_PEWS/": [
		8456,
		8456
	],
	"./Calc_PEWS/Info": [
		7760,
		7760
	],
	"./Calc_PEWS/Info.tsx": [
		7760,
		7760
	],
	"./Calc_PEWS/index": [
		8456,
		8456
	],
	"./Calc_PEWS/index.tsx": [
		8456,
		8456
	],
	"./Calc_PSI": [
		1975,
		1975
	],
	"./Calc_PSI/": [
		1975,
		1975
	],
	"./Calc_PSI/Info": [
		4151,
		4151
	],
	"./Calc_PSI/Info.tsx": [
		4151,
		4151
	],
	"./Calc_PSI/index": [
		1975,
		1975
	],
	"./Calc_PSI/index.tsx": [
		1975,
		1975
	],
	"./Calc_Padua": [
		2379,
		2379
	],
	"./Calc_Padua/": [
		2379,
		2379
	],
	"./Calc_Padua/Info": [
		5376,
		5376
	],
	"./Calc_Padua/Info.tsx": [
		5376,
		5376
	],
	"./Calc_Padua/index": [
		2379,
		2379
	],
	"./Calc_Padua/index.tsx": [
		2379,
		2379
	],
	"./Calc_RASS": [
		8584,
		8584
	],
	"./Calc_RASS/": [
		8584,
		8584
	],
	"./Calc_RASS/Info": [
		4926,
		4926
	],
	"./Calc_RASS/Info.tsx": [
		4926,
		4926
	],
	"./Calc_RASS/index": [
		8584,
		8584
	],
	"./Calc_RASS/index.tsx": [
		8584,
		8584
	],
	"./Calc_SOFA": [
		8914,
		8914
	],
	"./Calc_SOFA/": [
		8914,
		8914
	],
	"./Calc_SOFA/Info": [
		2556,
		2556
	],
	"./Calc_SOFA/Info.tsx": [
		2556,
		2556
	],
	"./Calc_SOFA/index": [
		8914,
		8914
	],
	"./Calc_SOFA/index.jsx": [
		8914,
		8914
	],
	"./Calc_STOPBANG": [
		2057,
		2057
	],
	"./Calc_STOPBANG/": [
		2057,
		2057
	],
	"./Calc_STOPBANG/Info": [
		3608,
		3608
	],
	"./Calc_STOPBANG/Info.tsx": [
		3608,
		3608
	],
	"./Calc_STOPBANG/index": [
		2057,
		2057
	],
	"./Calc_STOPBANG/index.tsx": [
		2057,
		2057
	],
	"./Calc_Schwartz": [
		719,
		719
	],
	"./Calc_Schwartz/": [
		719,
		719
	],
	"./Calc_Schwartz/Info": [
		9738,
		9738
	],
	"./Calc_Schwartz/Info.tsx": [
		9738,
		9738
	],
	"./Calc_Schwartz/index": [
		719,
		719
	],
	"./Calc_Schwartz/index.jsx": [
		719,
		719
	],
	"./Calc_TIMIIndex": [
		1844,
		1844
	],
	"./Calc_TIMIIndex/": [
		1844,
		1844
	],
	"./Calc_TIMIIndex/Info": [
		2056,
		2056
	],
	"./Calc_TIMIIndex/Info.tsx": [
		2056,
		2056
	],
	"./Calc_TIMIIndex/index": [
		1844,
		1844
	],
	"./Calc_TIMIIndex/index.jsx": [
		1844,
		1844
	],
	"./Calc_TIMINStemi": [
		3884,
		3884
	],
	"./Calc_TIMINStemi/": [
		3884,
		3884
	],
	"./Calc_TIMINStemi/Info": [
		86,
		86
	],
	"./Calc_TIMINStemi/Info.tsx": [
		86,
		86
	],
	"./Calc_TIMINStemi/index": [
		3884,
		3884
	],
	"./Calc_TIMINStemi/index.jsx": [
		3884,
		3884
	],
	"./Calc_TIMIStemi": [
		4478,
		1120
	],
	"./Calc_TIMIStemi/": [
		4478,
		1120
	],
	"./Calc_TIMIStemi/Info": [
		645,
		645
	],
	"./Calc_TIMIStemi/Info.tsx": [
		645,
		645
	],
	"./Calc_TIMIStemi/index": [
		4478,
		1120
	],
	"./Calc_TIMIStemi/index.jsx": [
		4478,
		1120
	],
	"./Calc_Tc6m": [
		5729,
		5729
	],
	"./Calc_Tc6m/": [
		5729,
		5729
	],
	"./Calc_Tc6m/Info": [
		9261,
		9261
	],
	"./Calc_Tc6m/Info.tsx": [
		9261,
		9261
	],
	"./Calc_Tc6m/index": [
		5729,
		5729
	],
	"./Calc_Tc6m/index.jsx": [
		5729,
		5729
	],
	"./Calc_UKPDS": [
		980,
		980
	],
	"./Calc_UKPDS/": [
		980,
		980
	],
	"./Calc_UKPDS/Info": [
		7883,
		7883
	],
	"./Calc_UKPDS/Info.tsx": [
		7883,
		7883
	],
	"./Calc_UKPDS/index": [
		980,
		980
	],
	"./Calc_UKPDS/index.tsx": [
		980,
		980
	],
	"./Calc_WAT": [
		9981,
		9981
	],
	"./Calc_WAT/": [
		9981,
		9981
	],
	"./Calc_WAT/Info": [
		2544,
		2544
	],
	"./Calc_WAT/Info.tsx": [
		2544,
		2544
	],
	"./Calc_WAT/index": [
		9981,
		9981
	],
	"./Calc_WAT/index.tsx": [
		9981,
		9981
	],
	"./Calc_WellsTEP": [
		9912,
		9912
	],
	"./Calc_WellsTEP/": [
		9912,
		9912
	],
	"./Calc_WellsTEP/Info": [
		8539,
		8539
	],
	"./Calc_WellsTEP/Info.tsx": [
		8539,
		8539
	],
	"./Calc_WellsTEP/index": [
		9912,
		9912
	],
	"./Calc_WellsTEP/index.jsx": [
		9912,
		9912
	],
	"./Calc_WellsTVP": [
		1016,
		1016
	],
	"./Calc_WellsTVP/": [
		1016,
		1016
	],
	"./Calc_WellsTVP/Info": [
		5371,
		5371
	],
	"./Calc_WellsTVP/Info.tsx": [
		5371,
		5371
	],
	"./Calc_WellsTVP/index": [
		1016,
		1016
	],
	"./Calc_WellsTVP/index.jsx": [
		1016,
		1016
	],
	"./Calc_WoodDownes": [
		1969,
		1969
	],
	"./Calc_WoodDownes/": [
		1969,
		1969
	],
	"./Calc_WoodDownes/Info": [
		1157,
		1157
	],
	"./Calc_WoodDownes/Info.tsx": [
		1157,
		1157
	],
	"./Calc_WoodDownes/index": [
		1969,
		1969
	],
	"./Calc_WoodDownes/index.tsx": [
		1969,
		1969
	],
	"./index": [
		2176
	],
	"./index.tsx": [
		2176
	],
	"./style": [
		6325
	],
	"./style.js": [
		6325
	],
	"./useCalcLinks": [
		4979
	],
	"./useCalcLinks.tsx": [
		4979
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4409;
module.exports = webpackAsyncContext;